import {
  TargetRecipientType,
  TargetStatus,
  TargetStatusGroup,
  TargetType,
} from '../../services/modules/target/target.types';

export const TARGET_NAME_MAX_LENGTH = 120;
export const TARGET_PERIOD_MAX_COLLECTIONS = 20;
export const TARGET_EMPTY_VALUE = '-';
export const TARGET_ZERO_VALUE = '0';
export const TARGET_DATE_FORMAT = 'dd/MM/yy';
export const TARGET_FIRST_LEVEL_DEPTH = 0;

export const TARGET_MASS_ACTION_MAX_IDS = 500;

export const TARGET_STATUSES_BY_GROUP: Record<TargetStatusGroup, TargetStatus[]> = {
  [TargetStatusGroup.DRAFTS]: [TargetStatus.SUGGESTED, TargetStatus.DRAFT],
  [TargetStatusGroup.OPEN]: [TargetStatus.OPEN],
  [TargetStatusGroup.CLOSED]: [
    TargetStatus.CLOSED,
    TargetStatus.CLOSED_WON,
    TargetStatus.CLOSED_LOST,
  ],
  [TargetStatusGroup.CANCELED]: [TargetStatus.CANCELED],
};

export const TARGET_TYPE_BY_RECIPIENT_TYPE: Record<TargetRecipientType, TargetType> = {
  [TargetRecipientType.CUSTOMER]: TargetType.BRAND_TO_CUSTOMER,
  [TargetRecipientType.SALES_REPRESENTATIVE]: TargetType.BRAND_TO_SALES_REPRESENTATIVE,
};
